// Helpers for coloring edges in the result view by the selected metric
// (diameter or first/final year pipe flow). Thickness encodes the value too;
// the color adds an intensity gradient (green = low → red = high).

// Reads an edge's numeric calc value for the given label, or null.
export function getEdgeMetricValue(element, label) {
  const prop = element?.calc?.find((p) => p.label === label);
  if (!prop || prop.value === "" || prop.value == null) return null;
  const value = Number(prop.value);
  return Number.isNaN(value) ? null : value;
}

// Min/max of the selected metric across all edges, or null if no edge has one.
export function getMetricRange(mapElements = [], label) {
  let min = Infinity;
  let max = -Infinity;
  mapElements.forEach((element) => {
    if (element.type !== "edge") return;
    const value = getEdgeMetricValue(element, label);
    if (value == null) return;
    if (value < min) min = value;
    if (value > max) max = value;
  });
  if (min === Infinity) return null;
  return { min, max };
}

// Maps a metric value onto a color. For the "diameter" metric a full rainbow
// gradient is used (low = blue → high = red, sweeping through cyan/green/yellow);
// every other metric (the pipe flows) keeps the blue shade: low = light blue →
// high = dark blue. Returns null when there is no usable value/range so the
// caller can fall back to the default edge color.
export function metricColor(value, range, metric = "diameter") {
  if (value == null || Number.isNaN(value) || !range || range.min == null)
    return null;
  const span = range.max - range.min;
  // clamp to [0, 1] so values outside the fixed scale (e.g. a first-year flow
  // below the final-year minimum) still map onto the legend's gradient ends
  const raw = span > 0 ? (value - range.min) / span : 0.5;
  const t = Math.max(0, Math.min(1, raw));

  if (metric === "diameter") {
    // rainbow: low = blue (hue 240°) → high = red (hue 0°)
    const hue = 240 * (1 - t);
    return `hsl(${hue}, 85%, 50%)`;
  }

  const lightness = 80 - t * 55; // 80% (light blue) → 25% (dark blue)
  return `hsl(210, 85%, ${lightness}%)`;
}
